import config from '../../temp/config';

const getRequestBody = postCode => {
  return {
    postCode: postCode,
    addressFormatCode: config?.referenceData?.addressFormat,
    requestHeaders: {
      updatedBySystem: config?.referenceData?.systemEntityNumber,
      updatedByUser: config?.referenceData?.systemEntityNumber,
    },
  };
};

const lookupPostCode = (postCode, signal) => {
  return fetch(config?.endpoints?.postcodeValidation, {
    method: 'POST',
    body: JSON.stringify(getRequestBody(postCode)),
    headers: {
      'Content-Type': 'application/json',
    },
    signal,
  });
};

export default lookupPostCode;
